export default class _User {
    _id = '';
    name = '';
    email = '';
    role = '';
    token = '';
    $promise = undefined;
    isLoggedIn = false;
}
